// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
if (window.location.hostname === 'silkmiles.com') {
  window.location.href = window.location.href.replace(
    'silkmiles.com',
    'www.silkmiles.com'
  );
}
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Element from 'element-ui'
import i18n from './language'
import VuePdf from 'vue-pdf';
import 'normalize.css/normalize.css'
import '@/styles/element-variables.scss'
import '@/styles/index.scss' // global css
import "./assets/src/hotcss"
import './permission' // permission control

import request from '../src/utils/request'
import download from '../src/utils/download'
import { jsonFormData } from './utils/jsonFormData';
import SafeImage from '@/components/SafeImage.vue';
Vue.prototype.$http = request;
Vue.prototype.$download = download;
Vue.component('pdf', VuePdf);
Vue.component('SafeImage', SafeImage);
Vue.component('safe-image', SafeImage);
Vue.prototype.$form = jsonFormData;
Vue.config.productionTip = false
Vue.use(Element);

window.addEventListener('storage', (e) => {
  if (e.key === 'isLoggedIn' && !e.newValue) {
    store.commit('syncLogoutFromStorage')
    if (router.currentRoute.path !== '/login') {
      router.replace('/')
    }
  }
  if (e.key === 'isLoggedIn' && e.newValue === '1') {
    store.commit('syncSessionFromStorage')
  }
})

store.dispatch('initAuth').then(() => {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    store,
    i18n,
    router,
    components: { App },
    template: '<App/>'
  })
})



// WEBPACK FOOTER //
// ./src/main.js